module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"removeConfirm":"Are you sure you want to delete this note?"},"et":{"removeConfirm":"Are you sure you want to delete this note?"},"ru":{"removeConfirm":"Are you sure you want to delete this note?"}}')
  delete Component.options._Ctor
}
